/* eslint-disable @typescript-eslint/no-unused-vars */
/* eslint-disable react/prop-types */
import styled from '@emotion/styled';
import Icon from 'components/icon';
import React from 'react';
import { Alert } from 'react-bootstrap';

const CustomAlert = styled(Alert)`
  transition: box-shadow 300ms cubic-bezier(0.4, 0, 0.2, 1) 0ms;
  font-weight: 400;
  font-size: 0.875rem;
  display: flex;
  padding: 6px 16px;
`;

const IconBox = styled('div')`
  margin-right: 6px;
  padding: 7px 0px;
  display: flex;
  font-size: 22px;
  opacity: 0.9;
`;

const AlertWithIcon = ({
  title,
  body,
  icon,
  iconProp,
  containerClass,
  titleClass,
  button,
  // iconPercent,
  ...props
}) => {
  return (
    <CustomAlert {...props}>
      <div className="d-flex">
        <IconBox>
          <Icon icon={icon} {...iconProp} />
        </IconBox>
        <div className={`py-1 fs-9 ${containerClass}`}>
          {/* {iconPercent} */}
          {title ? (
            <p className={`${titleClass} mb-2 fs-8 fw-medium `}>{title}</p>
          ) : null}
          {body}
        </div>
      </div>
      {button}
    </CustomAlert>
  );
};

export default AlertWithIcon;
